/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function t(t,n=0){if(0===n)return t;const r=Math.cos(n),o=Math.sin(n),[c,e]=t;return[c*r+e*-o,c*o+e*r]}export{t as rotate};
